/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Box,
  Checkbox,
  Divider,
  Flex,
  Icon,
  Option,
  Select,
  Stack,
  Switch,
  Tab,
  Tabs,
  TabList,
  TabPanel,
  TabPanels,
  Text,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  storeSelector,
  templateSelector,
  usePolicyContext,
} from '@Policy/store';
import { useWhyDidYouUpdate } from 'src/utils/hooks';
import { DlpPolicyItem } from 'src/pages/Policy/utils/types';
import ActionNotification from './ActionNotification';
import ExceptionList from './Exceptions';

const ShareLink = () => {
  const { t } = useTranslation();
  return (
    <Box>
      <Tabs>
        <TabList>
          <Tab>{t('policy.rules')}</Tab>
          <Tab>{t('policy.actionAndNotification')}</Tab>
        </TabList>
        <TabPanels py="2x">
          <TabPanel>
            <ExceptionList />
          </TabPanel>
          <TabPanel>
            <ActionNotification />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};
export default React.memo(ShareLink);
